import React from 'react';
import classNames from 'classnames';
import Styles from './table-container.less';

const baseClass = Styles.table;
const allowedElements = [
  'TableHeader',
  'TableBody'
];

module.exports = React.createClass({
  displayName: 'TableContainer',
  propTypes: {
    className: React.PropTypes.string,
    pager: React.PropTypes.bool,
    sizer: React.PropTypes.bool
  },
  getChildren() {
    return React.Children.toArray(this.props.children)
      .filter(React.isValidElement)
      .filter((child) => {
        if(child.type.displayName === 'TableHeader') return true;
        if(child.type.displayName === 'TableBody') return true;
      });
  },
  getTableClass() {
    return classNames(baseClass, this.props.className);
  },
  getActionsClass() {
    return Styles.tableActions;
  },
  render: require('./table-container.rt')
});



/** WEBPACK FOOTER **
 ** ./src/table/table-container/table-container.js
 **/